import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useCreateOrUpdatePoll = () => {
  const createOrUpdatePoll = useCallback((pollPayload) => {
    const { id } = pollPayload;

    const requestParams = {
      method: id ? "PUT" : "POST",
      body: JSON.stringify(pollPayload),
      headers: { "Content-Type": "application/json" },
    };

    const url = `${API_BASE_URL}/api/v3/activity/${id ? `${id}/` : ""}`;
    return new Request(url, requestParams);
  }, []);
  return useRestMutation(createOrUpdatePoll);
};

export default useCreateOrUpdatePoll;
